import { render } from "./LearningBaseEditArticle.vue?vue&type=template&id=63acc5b5&scoped=true"
import script from "./LearningBaseEditArticle.vue?vue&type=script&lang=js"
export * from "./LearningBaseEditArticle.vue?vue&type=script&lang=js"

import "./LearningBaseEditArticle.vue?vue&type=style&index=0&id=63acc5b5&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63acc5b5"]])

export default __exports__